import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const canShow = (acces, item) => {
  // If acces is an object, check the specific access
  if (acces && typeof acces === 'object') {
    return acces[item] === true;
  }
  // Legacy support: if acces is a string (old role system)
  if (typeof acces === 'string') {
    const role = acces.toLowerCase().trim();
    if(role === 'admin') return true;
    if(role === 'caissier') return (item === 'commandes' || item === 'livreur');
    if(role === 'gestionnaire_stock') return (item === 'produit' || item === 'categorie');
  }
  return false;
};

export default function Sidebar(){
  const location = useLocation();
  const storedAcces = sessionStorage.getItem('Acces');
  let acces = null;
  try {
    acces = storedAcces ? JSON.parse(storedAcces) : null;
  } catch (e) {
    // Fallback to legacy role system
    const storedRole = sessionStorage.getItem('Role') || '';
    acces = storedRole ? storedRole : null;
  }
  const isActive = (path) => location.pathname === path;
  const showFooter = canShow(acces, 'footer');
  const showUtilisateur = canShow(acces, 'utilisateur');
  return (
    <div className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 " id="sidenav-main">
      <div className="sidenav-header">
        <i className="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav" />
        <a className="navbar-brand m-0" href=" " target="_blank">
          <img src="../assets/img/logo-ct-dark.png" className="navbar-brand-img h-100" alt="main_logo" />
          <span className="ms-1 font-weight-bold">admin</span>
        </a>
      </div>
      <hr className="horizontal dark mt-0" />
      <div className="collapse navbar-collapse  w-auto " id="sidenav-collapse-main">
        <ul className="navbar-nav">
          {canShow(acces,'commandes') && (
            <li className="nav-item">
              <Link className={`nav-link ${isActive('/') ? ' active' : ''}`} to="/">
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="ni ni-bullet-list-67" />
                </div>
                <span className="nav-link-text ms-1">Commandes</span>
              </Link>
            </li>
          )}
          {canShow(acces,'produit') && (
            <li className="nav-item">
              <Link className={`nav-link${isActive('/produit') ? ' active' : ''}`} to="/produit">
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="ni ni-bag-17" />
                </div>
                <span className="nav-link-text ms-1">Produit</span>
              </Link>
            </li>
          )}
          {canShow(acces,'categorie') && (
            <li className="nav-item">
              <Link className={`nav-link${isActive('/categorie') ? ' active' : ''}`} to="/categorie">
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="ni ni-collection" />
                </div>
                <span className="nav-link-text ms-1">Categorie</span>
              </Link>
            </li>
          )}
          {canShow(acces,'livreur') && (
            <li className="nav-item">
              <Link className={`nav-link${isActive('/livreur') ? ' active' : ''}`} to="/livreur">
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="ni ni-delivery-fast" />
                </div>
                <span className="nav-link-text ms-1">Livreur</span>
              </Link>
            </li>
          )}
          {canShow(acces,'clients') && (
            <li className="nav-item">
              <Link className={`nav-link${isActive('/clients') ? ' active' : ''}`} to="/clients">
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="ni ni-circle-08" />
                </div>
                <span className="nav-link-text ms-1">Clients</span>
              </Link>
            </li>
          )}
          {(showFooter || showUtilisateur) && (
            <li className="nav-item mt-3">
              <h6 className="ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6">Configuration</h6>
            </li>
          )}
          {showFooter && (
            <li className="nav-item">
              <Link className={`nav-link${isActive('/footer') ? ' active' : ''}`} to="/footer">
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="ni ni-settings-gear-65" />
                </div>
                <span className="nav-link-text ms-1">Gestion Footer</span>
              </Link>
            </li>
          )}
          {showUtilisateur && (
            <li className="nav-item">
              <Link className={`nav-link${isActive('/utilisateur') ? ' active' : ''}`} to="/utilisateur">
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="ni ni-single-02" />
                </div>
                <span className="nav-link-text ms-1">Utilisateur</span>
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}


